// styles.js
import styled from 'styled-components';

/* --- Page containers --- */

export const Container = styled.div`
  max-width: 48rem; /* ~max-w-3xl */
  margin: 0 auto;
  padding: 1rem;

  @media (min-width: 640px) {
    padding: 1.5rem; /* sm:p-6 */
  }
`;

export const CenterSection = styled.div`
  text-align: center;
  padding-top: 3rem; /* py-12 */
  padding-bottom: 3rem;
`;

/* --- Success icon bubble --- */

export const IconCircle = styled.div`
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 32px auto;
`;

/* --- Headings & text --- */

export const Title = styled.h1`
  margin: 0 0 1rem 0; /* mb-4 */
  color: #231F20; /* text-green-800 */
  font-weight: 500; /* font-bold */
  font-size: 32px; /* text-3xl */

  @media (min-width: 640px) {
    font-size: 2.25rem; /* sm:text-4xl */
  }
`;

export const TextStack = styled.div`
  color: #231F20; /* text-gray-700 */
  font-size: 14px;
  font-weight: 400;
  display: grid;
  gap: 0.75rem; /* space-y-3 */
  margin-bottom: 2rem; /* mb-8 */
  b {
    display: inline-block;
  }
`;

export const EmphasisGreen = styled.p`
  color: #16a34a; /* text-green-600 */
  font-weight: 600; /* font-medium */
  margin: 0;
`;

export const Strong = styled.p`
  font-weight: 400; /* font-semibold */
  margin: 0;
  b {
    font-weight: 600;
  }
`;

/* --- Info card (replaces DCard) --- */

export const InfoCard = styled.div`
  background: #f1f5f7;
  border: 0;
  border-radius: 1rem; /* rounded-2xl */
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05); /* shadow-lg */
  padding: 1.25rem; /* p-5-ish */
  margin-bottom: 2rem; /* mb-8 */
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem; /* gap-3 */
`;

export const InfoDot = styled.div`
  width: 1.25rem; /* w-5 */
  height: 1.25rem; /* h-5 */
  background: #2563eb; /* bg-blue-600 */
  color: #ffffff;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.125rem; /* mt-0.5 */
  font-size: 0.75rem; /* text-xs */
  font-weight: 700; /* font-bold */
`;

export const InfoBody = styled.div`
  text-align: left;
`;

export const InfoTitle = styled.h3`
  margin: 0 0 0.5rem 0; /* mb-2 */
  color: #1e40af; /* text-blue-800 */
  font-weight: 600; /* font-semibold */
`;

export const InfoText = styled.div`
  color: #1d4ed8; /* text-blue-700 */
  font-size: 0.875rem; /* text-sm */
  display: grid;
  gap: 0.5rem; /* space-y-2 */
`;

/* --- Buttons --- */

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: column; /* flex-col */
  gap: 1rem; /* gap-4 */
  justify-content: center;
  margin-bottom: 2rem; /* mb-8 */

  @media (min-width: 640px) {
    flex-direction: row; /* sm:flex-row */
  }
`;

export const PrimaryButton = styled.button`
  color: #ffffff; /* text-white */
  background: #008427;
  padding: 0.75rem 2rem; /* px-8 py-3 */
  font-size: 20px; /* text-lg */
  font-weight: 600; /* font-semibold */
  border: 0;
  border-radius: 9999px; /* rounded-full */
  cursor: pointer;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05); /* shadow-lg */
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 12px 20px -5px rgba(0, 0, 0, 0.15),
      0 6px 8px -3px rgba(0, 0, 0, 0.06); /* hover:shadow-xl */
  }
`;

export const BottomActions = styled.div`
  text-align: center;
`;

export const OutlineButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent; /* bg-transparent */
  color: #16a34a; /* text-green-600 */
  border: 1px solid #16a34a; /* border-green-600 */
  padding: 0.5rem 1.5rem; /* px-6 py-2 */
  border-radius: 0.5rem;
  cursor: pointer;

  &:hover {
    background: #f0fdf4; /* hover:bg-green-50 */
  }

  svg {
    width: 1rem; /* w-4 */
    height: 1rem; /* h-4 */
  }
`;
